import React, { useState } from 'react';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import EditNoteIcon from '@mui/icons-material/EditNote';

import EditModal from '../modals/EditModal';
import QualificationsField from '../../common/fields/QualificationsField';
import PrimaryButton from '../../common/buttons/PrimaryButton';
import AppSnackbar from '../../common/popups/AppSnackbar';
import useProfileSection from '../../../hooks/useProfileSection';

function QualificationSection({ teacher, canEdit, onUpdate }) {
  const { isEditing, openModal, closeModal, save, errors, loading, snackbarProps } =
    useProfileSection(teacher.profileId, onUpdate);

  const [modalData, setModalData] = useState({
    qualifications: teacher.qualifications || [],
  });

  const handleSave = (e) => {
    e.preventDefault();
    save(modalData, { successMessage: 'Qualifications updated!' });
  };

  return (
    <div className="pt-10 mb-6 h-full">
      <div className="flex justify-between items-start mb-6">
        <h2 className="uppercase text-2xl flex items-center">
          <span className="bg-gradient-primary w-2 h-8 mr-3 rounded-full"></span>
          QUALIFICATIONS
        </h2>
        {canEdit && (
          <button onClick={openModal} className="text-orange-500 hover:text-orange-400">
            <EditNoteIcon fontSize="large" />
          </button>
        )}
      </div>

      <hr className="mt-5 mb-8 border-white/20 w-full" />

      <div className="space-y-4 sm:ps-10 ps-4">
        {teacher.qualifications?.length > 0 ? (
          teacher.qualifications.map((qual, idx) => (
            <div key={idx} className="flex items-start">
              <TaskAltIcon className="mr-2 text-primary sm:mt-0 mt-2" />
              <div>
                <h3 className="text-white capitalize font-semibold text-lg sm:text-xl">
                  {qual.degree}
                </h3>
                <p className="text-gray-400 italic text-sm">{qual.institution}</p>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center py-10 bg-gradient-glass rounded-lg">
            <p className="text-gray-400 text-lg">No qualifications added yet.</p>
          </div>
        )}
      </div>

      <EditModal isOpen={isEditing} onClose={closeModal} title="Edit Qualifications">
        <form onSubmit={handleSave}>
          <div className="mb-10">
            <QualificationsField
              value={modalData.qualifications}
              onChange={(q) => setModalData({ ...modalData, qualifications: q })}
              required
              error={!!errors.qualifications}
              helperText={errors.qualifications}
            />
          </div>
          <div className="flex justify-end">
            <PrimaryButton className="w-full sm:w-auto" type="submit" disabled={loading}>
              {loading ? 'Saving...' : 'Save Changes'}
            </PrimaryButton>
          </div>
        </form>
      </EditModal>

      <AppSnackbar {...snackbarProps} />
    </div>
  );
}

export default QualificationSection;
